<sd-6-17-1-icon library="{{ iconLibrary }}" [name]="iconName()" [attr.color]="iconColor()"></sd-6-17-1-icon>